import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaTags }          from '@react-icons/all-files/fa/FaTags';
import { FaProjectDiagram } from '@react-icons/all-files/fa/FaProjectDiagram';
import { FaCog }            from '@react-icons/all-files/fa/FaCog';
import { FaHome }           from '@react-icons/all-files/fa/FaHome';
import { FaPlus }           from '@react-icons/all-files/fa/FaPlus';
import Breadcrumb    from '../../../../commons/Breadcrumb';
import PageHeader    from '../../../../commons/PageHeader';
import PageAlert, { usePageAlert } from '../../../../commons/PageAlert';
import Confirm, { useConfirm }     from '../../../../commons/Confirm';
import { EditButton, DeleteButton, RenderActions } from '../../../../commons/DataGridActions';
import ProfaseDataGrid from '../../../../commons/Datagrid';
import { useAppDispatch, useAppSelector } from '../../../../store';
import { getEntities, deleteEntity, reset } from '../../../../manager/tipo-actividad.reducer';

const BASE = '/configuracion/workflow/tipos-actividad';

export default function TipoActividadPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const topRef   = useRef<HTMLDivElement>(null);

  const entities      = useAppSelector(s => s.tipoActividad.entities);
  const totalItems    = useAppSelector(s => s.tipoActividad.totalItems);
  const loading       = useAppSelector(s => s.tipoActividad.loading);
  const updating      = useAppSelector(s => s.tipoActividad.updating);
  const updateSuccess = useAppSelector(s => s.tipoActividad.updateSuccess);

  const [rows, setRows]             = useState<any[]>([]);
  const [lastParams, setLastParams] = useState<any>(null);

  const { alert, showToast }                               = usePageAlert();
  const { confirmConfig, ask, dismiss, setConfirmLoading } = useConfirm();

  useEffect(() => {
    const msg = (location.state as any)?.successMsg;
    if (msg) { showToast('success', msg); window.history.replaceState({}, ''); }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (updateSuccess) {
      dispatch(reset());
      dismiss();
      if (lastParams) dispatch(getEntities(lastParams));
      showToast('success', 'Tipo de actividad eliminado correctamente.');
    }
  }, [updateSuccess]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => { setConfirmLoading(updating); }, [updating]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { setRows(entities ?? []); }, [entities]);

  const fetchData = (params: any) => {
    setLastParams(params);
    dispatch(getEntities(params));
  };

  const renderActions = (params: any) => (
    <RenderActions>
      <EditButton onClick={() => navigate(`${BASE}/${params.row.id}/edit`)} />
      <DeleteButton onClick={() => {
        ask(
          <>¿Confirmas que deseas eliminar <strong>{params.row.nombre}</strong>? Esta acción no se puede deshacer.</>,
          () => dispatch(deleteEntity(params.row.id)),
          { title: 'Eliminar Tipo de Actividad', confirmLabel: 'Eliminar', variant: 'danger' },
        );
        topRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }} />
    </RenderActions>
  );

  const cols = [
    { field: 'id',          headerName: 'ID',          flex: 0.5 },
    { field: 'descripcion', headerName: 'Descripción', flex: 3 },
    { field: '__actions',   headerName: '',             flex: 1, renderCell: renderActions },
  ];

  const filters = [
    { label: 'Nombre',      name: 'nombre' },
    { label: 'Descripción', name: 'descripcion' },
  ];

  return (
    <div style={g.page} ref={topRef}>
      <Breadcrumb items={[
        { label: 'Inicio',              to: '/',                       icon: <FaHome /> },
        { label: 'Configuración',       to: '/configuracion',          icon: <FaCog /> },
        { label: 'Workflow',            to: '/configuracion/workflow', icon: <FaProjectDiagram /> },
        { label: 'Tipos de Actividad',                                 icon: <FaTags /> },
      ]} />

      <PageHeader
        icon={<FaTags />}
        iconColor="#8b5cf6"
        title="Tipos de Actividad"
        subtitle="Gestión de tipos de actividad"
        action={{
          label: <><FaPlus style={{ marginRight: 6 }} />Nuevo Tipo</>,
          onClick: () => navigate(`${BASE}/new`),
          color: '#8b5cf6',
        }}
      />

      <Confirm config={confirmConfig} />
      {alert && <PageAlert alert={alert} />}

      <ProfaseDataGrid
        cols={cols}
        title=""
        filters={filters}
        fetch={fetchData}
        rowCount={totalItems}
        loading={loading}
        rows={rows}
      />
    </div>
  );
}

const g: Record<string, React.CSSProperties> = {
  page: { display: 'flex', flexDirection: 'column', gap: 24 },
};
